import { render, staticRenderFns } from "./PXP.vue?vue&type=template&id=2f1f7528&"
import script from "./PXP.vue?vue&type=script&lang=js&"
export * from "./PXP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports